import { render, staticRenderFns } from "./Topicsview.vue?vue&type=template&id=371f56a0&scoped=true"
import script from "./Topicsview.vue?vue&type=script&lang=js"
export * from "./Topicsview.vue?vue&type=script&lang=js"
import style0 from "./Topicsview.vue?vue&type=style&index=0&id=371f56a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371f56a0",
  null
  
)

export default component.exports